define(
	'C3.ShoppingExtensions.CartPage.QuickAdd.List.View',
	[
		'SCView', 
		 'c3_shoppingextensions_cartpage_quickadd_list.tpl',
		 'Backbone.CollectionView',
  		'Backbone.CompositeView',
  		'C3.ShoppingExtensions.CartPage.QuickAdd.List.Cell.View',
	],
	function(
		SCViewComponent, 
		c3_shoppingextensions_cartpage_quickadd_list_tpl,
		 CollectionView, 
  		CompositeView, 
  		SiteSearchExtensionListCellView, 
	) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function QuickAddListView(options) {
			SCView.call(this);

			this.options = options || {};

			this.template = c3_shoppingextensions_cartpage_quickadd_list_tpl;

			CompositeView.add(this);
	      this.application = options.application;
	      this.collection = options.collection;
	      this.view=SiteSearchExtensionListCellView;
		}

		// Inherit parent instance methods.
		QuickAddListView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		QuickAddListView.prototype.constructor = QuickAddListView;

		QuickAddListView.prototype.getChildViews = function() {
			
			return {
				 'SiteSearchExtension.Collection': function() {
			        return new CollectionView({
			          'childView': this.view,
			          'collection': this.collection,
			          'viewsPerRow': 1
			        });
			      }
			}
		}

		QuickAddListView.prototype.getContext = function() {
			
			return {
				
			}
		}

		// Return the AMD constructor.
		return QuickAddListView;
	}
);
